/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to editor.reducer.js
 */

export const TYPES = {
};
